import {CLOSE_PROGRESS, OPEN_PROGRESS} from '../actions'

const progressReducer = (state={open: false, message: ''}, action) => {
	switch(action.type) {
		case CLOSE_PROGRESS:
			return Object.assign({}, state, {open: false})
		case OPEN_PROGRESS:
			return Object.assign({open: true, message: action.message})
		default:
			return state;
	}
}

export default progressReducer


// WEBPACK FOOTER //
// ./src/reducers/ProgressReducer.js